export const ADD_COURSE_ACTION = "addCourseAct";
